export class ApiUrl {
    static v1(...urlParts: string[]) {
        return ApiUrl._url(urlParts.join("/"), 1);
    }

    //Don't use unless needed. Use the earlier version
    private static _url(url: string, version: number) {
        if (url.startsWith("/")) url = url.slice(1);
        return `/api/${version}/${url}`;
    }
}
